import styled from "styled-components"

const BaseHelperText = styled.div`
  display: inline-flex;
  align-items: center;

  color: var(--color-text-200);
  &:not(:only-child) {
    margin-top: var(--size-2);
  }
  > svg:first-child {
    margin-right: var(--size-1);
    width: var(--size-2_5);
    height: var(--size-2_5);
  }
  &.state--info > svg:first-child {
    fill: var(--color-primary);
  }
  &.state--success > svg:first-child {
    fill: var(--color-success);
  }
  &.state--warning > svg:first-child {
    fill: var(--color-warning);
  }
  &.state--error > svg:first-child {
    fill: var(--color-error);
  }
`
const BaseFormControl = styled.div`
  display: flex;
  flex-direction: column;

  &:not(:only-child) {
    margin-bottom: var(--size-4);
  }
`
const BaseFormRow = styled.div`
  display: flex;
  align-items: flex-start;
  @media (max-width: 1024px) {
    flex-direction: column;
    > * {
      width: 100%;
    }
    > *:not(:last-child) {
      margin-right: 0;
    }
  }

  @media (min-width: 1024px) {
    > * {
      flex-basis: 0;
      flex-grow: 1;

      &:not(:last-child) {
        margin-right: var(--size-4);
      }
    }
  }
`
export interface HelperTextProps extends React.ComponentPropsWithoutRef<"div"> {
  state?: "success" | "warning" | "error" | "info"
}

export interface FormControlProps
  extends React.ComponentPropsWithoutRef<"div"> {}
interface IFormControl extends React.FC<FormControlProps> {
  HelperText: React.FC<HelperTextProps>
}

const FormControl: IFormControl = ({ ...props }) => (
  <BaseFormControl {...props} />
)

const HelperText: React.FC<HelperTextProps> = ({
  children,
  state,
  className = "",
  ...props
}) => (
  <BaseHelperText className={`state--${state} ${className} caption`} {...props}>
    {state === "info" && (
      <svg viewBox="0 0 14 14">
        <path d="M7.00004 0.333252C3.32004 0.333252 0.333374 3.31992 0.333374 6.99992C0.333374 10.6799 3.32004 13.6666 7.00004 13.6666C10.68 13.6666 13.6667 10.6799 13.6667 6.99992C13.6667 3.31992 10.68 0.333252 7.00004 0.333252ZM7.66671 10.3333H6.33338V8.99992H7.66671V10.3333ZM7.66671 7.66659H6.33338V3.66659H7.66671V7.66659Z" />
      </svg>
    )}
    {state === "success" && (
      <svg viewBox="0 0 14 14">
        <path d="M7.00004 0.333252C3.32004 0.333252 0.333374 3.31992 0.333374 6.99992C0.333374 10.6799 3.32004 13.6666 7.00004 13.6666C10.68 13.6666 13.6667 10.6799 13.6667 6.99992C13.6667 3.31992 10.68 0.333252 7.00004 0.333252ZM5.66671 10.3333L2.33337 6.99992L3.27337 6.05992L5.66671 8.44659L10.7267 3.38659L11.6667 4.33325L5.66671 10.3333Z" />
      </svg>
    )}
    {state === "warning" && (
      <svg viewBox="0 0 14 14">
        <path d="M7.00004 0.333252C3.32004 0.333252 0.333374 3.31992 0.333374 6.99992C0.333374 10.6799 3.32004 13.6666 7.00004 13.6666C10.68 13.6666 13.6667 10.6799 13.6667 6.99992C13.6667 3.31992 10.68 0.333252 7.00004 0.333252ZM7.66671 10.3333H6.33338V8.99992H7.66671V10.3333ZM7.66671 7.66659H6.33338V3.66659H7.66671V7.66659Z" />
      </svg>
    )}
    {state === "error" && (
      <svg viewBox="0 0 14 14">
        <path d="M6.99998 0.333252C3.31998 0.333252 0.333313 3.31992 0.333313 6.99992C0.333313 10.6799 3.31998 13.6666 6.99998 13.6666C10.68 13.6666 13.6666 10.6799 13.6666 6.99992C13.6666 3.31992 10.68 0.333252 6.99998 0.333252ZM7.66665 10.3333H6.33331V8.99992H7.66665V10.3333ZM7.66665 7.66659H6.33331V3.66659H7.66665V7.66659Z" />
      </svg>
    )}
    {children}
  </BaseHelperText>
)
FormControl.HelperText = HelperText

export const FormRow: React.FC<React.ComponentPropsWithoutRef<"div">> = (
  props
) => <BaseFormRow {...props} />
export default FormControl
